import { FlatList } from '@codehesion-za/headless';

import {
  ZAFlag,
  USAFlag,
  UKFlag,
  MWFlag,
  AustraliaFlag,
  BotswanaFlag,
  SouthSudanFlag,
  NamibiaFlag,
  ZimFlag,
  ZambiaFLag,
} from '@project/assets';
import { MalawiTableProps } from './types';
import { BankInfo } from './bank-info';
import './bank-info.css';

const MALAWI_TABLE_DATA = [
  { accountNumber: '5460000004354', currency: 'MWK' },
  { accountNumber: '5460000004398', currency: 'USD' },
  { accountNumber: '5460000004399', currency: 'EUR' },
  { accountNumber: '5460000004400', currency: 'GBP' },
  { accountNumber: '5460000004401', currency: 'ZAR' },
];
const ZAMBIA_BANKS_1 = [
  { accountNumber: '63107856354', currency: 'USD' },
  { accountNumber: '63107856370', currency: 'ZAR' },
  { accountNumber: '63107856387', currency: 'ZMW' },
];
const ZAMBIA_BANKS_2 = [
  { accountNumber: '5622500005091', currency: 'GBP' },
  { accountNumber: '5622500005093', currency: 'EURO' },
  { accountNumber: '5622500005105', currency: 'USD' },
];

const RenderItem = ({ item, index }: { item: MalawiTableProps; index: number }) => (
  <tr key={`${index}-${item.accountNumber}`}>
    <td>{item.accountNumber}</td>
    <td className="text-sm uppercase">KFM International</td>
    <td>{item.currency}</td>
  </tr>
);

export const BankInfoDisplay: React.FC = () => (
  <div className="mt-20 w-full">
    <div className="">
      <div className="space-y-2">
        <div className="p-2 shadow-md">
          <BankInfo
            imageSrc={USAFlag}
            country="USA"
            bankName="JPcccc Morgan Chase Bank"
            bankAddress="383 MADISON AVENUE, NEW YORK NY 10179, US"
            accountName="KFM International Inc"
            accountNumber="696086951"
            recipientPhoneNumber="+1-929-619-5433"
            swiftCode="CHASUS33"
          />
        </div>
        <div className="p-2 shadow-md">
          <BankInfo
            imageSrc={ZAFlag}
            country="South Africa"
            bankName="First National Bank"
            bankAddress="Corner Rivonia Road and 5th Street, Level 5, Shop 5-11, Sandhurst, Sandton, Gauteng, South Africa"
            accountName="Kingdom Financiers Ministries International NPC"
            accountNumber="62880758746"
            branchCode="254605"
            swiftCode="FIRNZAJJ"
          />
        </div>
      </div>
      <div className="space-y-2">
        <div className="p-2 shadow-md">
          <BankInfo
            imageSrc={UKFlag}
            country="United Kingdom (UK)"
            bankName="NatWest Bank"
            bankAddress="Service Centre, Bede house, 11 Western Boulevard, Leicester, LE2 7EJ"
            accountName="KFM INTERNATIONAL UK"
            accountNumber="41657675"
            abaSwiftBicCode="NWBKGB2125D"
            sortCode="601235"
          />
        </div>
        <div className="p-2 shadow-md">
          <BankInfo
            imageSrc={AustraliaFlag}
            country="Australia"
            bankName="Westpac Banking Corporation"
            bankAddress="Shop 1021-1022 Westfield Shopping Town, Macquarie Street, Liverpool NSW 2170"
            accountName="KFM Financiers Ministries International (Australia)"
            accountNumber="153964"
            abaSwiftBicCode="WPACAU2S"
          />
        </div>
        <div className="p-2 shadow-md">
          <BankInfo
            imageSrc={BotswanaFlag}
            country="Botswana"
            bankName="First National Bank of Botswana Ltd."
            bankAddress="First Place Branch, Plot 54362, First Place, CBD"
            accountName="KFM INTERNATIONAL BOTSWANA (PTY)LTD"
            accountNumber="63033034850"
            abaSwiftBicCode="FIRNBWGX"
            sortCode="281467"
          />
        </div>
        <div className="p-2 shadow-md">
          <BankInfo
            imageSrc={SouthSudanFlag}
            country="South Sudan"
            bankName="The Pan African Bank (ECO Bank)"
            bankAddress="Stadium Branch, Juba-South Sudan"
            accountName="KFM International South Sudan"
            accountNumber="USD: 6950008355 SSP: 6950008356"
            abaSwiftBicCode="ECOCSSJBXXX"
            recipientPhoneNumber="+211929416819"
          />
        </div>
        <div className="p-2 shadow-md">
          <BankInfo
            imageSrc={NamibiaFlag}
            country="NAMIBIA"
            bankName="FNB"
            bankAddress="Windhoek Main Branch"
            accountName="Kingdom Financiers Millionaires International (KFMI)"
            accountNumber="64287116816"
            sortCode="280172"
          />
        </div>
        <div className="p-2 shadow-md">
          <BankInfo
            imageSrc={ZimFlag}
            country="ZIMBABWE"
            bankName="FBC Bank"
            bankAddress="Borrowdale"
            accountName="Kingdom Funds Ministries PVT Ltd (KFM)"
            accountNumber="6896082370121"
            abaSwiftBicCode="FBCPZWHA"
            sortCode="8127"
          />
        </div>
        <div className="p-2 shadow-md">
          <BankInfo
            imageSrc={ZambiaFLag}
            country="ZAMBIA 1"
            bankName="First National Bank (FNB)"
            accountName="Kingdom Financiers Ministries International"
            bankAddress="FNB Industrial Branch, Lumumba Road Lusaka - Zambia"
            abaSwiftBicCode="FIRNZMLX"
            sortCode="260002"
          />
          <table className="mt-2 xxs:-ml-2 xs:ml-0">
            <tr>
              <th>Account Number</th>
              <th>Account Name</th>
              <th>Currency</th>
            </tr>
            <FlatList items={ZAMBIA_BANKS_1} renderItem={RenderItem} />
          </table>
        </div>
        <div className="p-2 shadow-md">
          <BankInfo
            imageSrc={ZambiaFLag}
            country="ZAMBIA 2"
            bankName="The Pan African Bank (EcoBank)"
            accountName="Kingdom Financiers Ministries International"
            bankAddress="EZM Cairo Branch – Along Cairo Road, Lusaka, Zambia"
            abaSwiftBicCode="ECOCZMLU"
            sortCode="360003"
          />
          <table className="mt-2 xxs:-ml-2 xs:ml-0">
            <tr>
              <th>Account Number</th>
              <th>Account Name</th>
              <th>Currency</th>
            </tr>
            <FlatList items={ZAMBIA_BANKS_2} renderItem={RenderItem} />
          </table>
        </div>
        <div className="p-2 shadow-md">
          <BankInfo
            imageSrc={MWFlag}
            country="Malawi"
            bankName="Eco Bank"
            bankAddress="Corner Victoria Avenue and Henderson Street, Private Bag 389, Chichiri, Blantyre 3"
          />
          <table className="mt-2 xxs:-ml-2 xs:ml-0">
            <tr>
              <th>Account Number</th>
              <th>Account Name</th>
              <th>Currency</th>
            </tr>
            <FlatList items={MALAWI_TABLE_DATA} renderItem={RenderItem} />
          </table>
        </div>
      </div>
    </div>
  </div>
);
